import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { PeriodFilter, PeriodSort, PeriodVersionMap } from '../../lib/types/models/period/period'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPeriods<T extends keyof PeriodVersionMap>(
  input: PaginationRequest<PeriodFilter, T, T, PeriodSort> = {}
) {
  if (!input.sort) input.sort = { startDate: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.periods.getAll.url, null), input))
    .get<PaginationResponse<PeriodVersionMap[T]>>()
}
